<!--게시글 비밀글일 시 비밀번호 확인 모달 -->
<template>
  <el-dialog
    :visible.sync="passwordInputDialogVisible"
    title="비밀번호 입력"
    top="30vh"
    width="40rem"
    modal-append-to-body
    :close-on-click-modal="false"
    @close="close()"
  >
    <!-- scroll area -->
    <div class="scroll-element" v-bar="{ preventParentScroll: true }">
      <!-- el1 -->
      <div>
        <div class="input-group square-dot">
          <div class="input-row">
            <div class="item-label"><label class="is-label" for="boardPw">비밀번호</label></div>
            <div class="item-data mt10">
              <el-input
                id="boardPw"
                v-model="passwordInput"
                placeholder="비밀번호를 입력해 주세요."
                show-password
                @keypress.enter.native="pwdCheck()"
              />
              <div class="txt xxsm1">
                <em class="color-red" v-text="errorMsg"></em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="close" @click="close()">닫기</el-button>
      <el-button type="create" @click="pwdCheck()">확인</el-button>
    </div>
  </el-dialog>
</template>
<script>

import portalApiUrl from "~/constant/site/portal/portalApiUrl";

export default {
  props : {
    visible : {
      type : Boolean,
      required : true,
    },
    // 게시글 정보
    postingInfo : {
      type : Object,
      required : true,
    },
  },
  data() {
    return {
      passwordInputDialogVisible : this.visible,
      passwordInput : "",

      errorMsg : "",
    }
  },
  watch: {
    visible( val ) {
      this.passwordInputDialogVisible = val;
    },

    // 비밀번호 변경 시 에러 메세지 초기화
    passwordInput() {
      this.errorMsg = "";
    },
  },
  methods : {

    // 비밀번호 확인
    async pwdCheck() {

      if ( this.$validate.isEmpty( this.postingInfo?.postingOid ) ) {
        this.$util.rsAlertUtils.rsAlert( { title: "필수 입력", contents: "게시글 정보가 없습니다. \n 새로고침 후 다시 시도해주세요.", state : "warning" } );
        return false;
      }

      if ( this.$validate.isEmpty( this.passwordInput ) ) {
        this.errorMsg = "비밀번호를 입력해 주세요.";
        return false;
      }

      const param = {
        postingOid: this.postingInfo.postingOid,
        anonymousPwd: this.passwordInput,
      };

      const { data } = await this.$axios.post( portalApiUrl.USER.POSTING.CHECK_PWD, param );

      if ( this.$validate.isEmpty( data ) || false === data.result ) {

        this.errorMsg = this.$validate.isEmpty( data.errorMessage ) ? "비밀번호가 일치하지 않습니다." : data.errorMessage;
        return;
      }

      this.close();
      this.$emit( "success", this.postingInfo );
    },

    close() {

      this.passwordInputDialogVisible = false;
      this.passwordInput = "";
      this.errorMsg = "";
      this.$emit( "close" );
    }
  },
}

</script>



<style scoped>
</style>
